<ng-dialog-header title="Find Permit"></ng-dialog-header>
<mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="w-100" color="accent">
      <mat-label>Commodity</mat-label>
      <mat-select formControlName="commodity">
        <mat-option *ngFor="let commodity of commodities" [value]="commodity.key">{{ commodity.value }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="pb-5">
      <ns-autocomplete label="Permit No." [formCtrl]="form.controls.permitNumberSearch" [filter]="false" [isRequired]="true"
                       [data]="permits" [isLoading]="searchingPermits" type="simple" placeholder="Permit No" (selected)="selectPermit($event)">
      </ns-autocomplete>
    </div>
  </form>
</mat-dialog-content>
<ng-dialog-footer>
  <div class="d-flex justify-content-end w-100" dialog-actions>
    <button mat-stroked-button color="warn" aria-label="Cancel Button" mat-dialog-close>Cancel</button>
    <button mat-flat-button [disabled]="!form.valid" color="accent" aria-label="Permit search" (click)="emitLoadPermit()">OK</button>
  </div>
</ng-dialog-footer>
